import { combineReducers } from 'redux'
import auth from '../modules/auths/reducer'
import categories from '../modules/categories/reducer'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
const buildPersitReducer = (key, reducerIns, opts) => {
  const persistConfig = {
    key,
    storage,
    ...opts,
  }
  return persistReducer(persistConfig, reducerIns)
}
const rootReducer = combineReducers({
  auth,
  categories: buildPersitReducer('categories', categories),
})

export default rootReducer
